import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntDropdownAreaComponent} from "./int-dropdown-area.component";
import {IntScrollContainerModule} from "../../containers";
import {IntDropdownAreaItemDirective} from "./int-dropdown-area-item.directive";

@NgModule({
  imports: [
    CommonModule,
    IntScrollContainerModule
  ],
  declarations: [
    IntDropdownAreaComponent,
    IntDropdownAreaItemDirective
  ],
  exports: [
    IntDropdownAreaComponent,
    IntDropdownAreaItemDirective
  ]
})
export class IntDropdownAreaModule {}
